import { motion } from "framer-motion";

// Approximate pin positions for major Indian cities/states
// in a 600x680 viewBox roughly mapped over a stylized Bharat outline.
const PINS = [
  { name: "New Delhi", x: 235, y: 175, primary: true },
  { name: "Mumbai", x: 165, y: 360 },
  { name: "Bengaluru", x: 245, y: 510 },
  { name: "Hyderabad", x: 270, y: 430 },
  { name: "Chennai", x: 295, y: 540 },
  { name: "Kolkata", x: 410, y: 305 },
  { name: "Lucknow", x: 295, y: 215 },
  { name: "Ahmedabad", x: 165, y: 290 },
  { name: "Bhubaneswar", x: 380, y: 375 },
  { name: "Guwahati", x: 470, y: 235 },
  { name: "Jaipur", x: 215, y: 235 },
];

// A stylized, simplified Bharat silhouette path (artistic, not cartographic).
const INDIA_PATH =
  "M260 50 C 295 55, 320 60, 340 80 C 355 95, 360 115, 380 125 C 410 135, 445 130, 475 150 C 495 165, 500 195, 495 220 C 485 250, 470 260, 460 285 C 450 305, 440 320, 425 335 C 405 360, 380 365, 365 380 C 355 395, 365 415, 360 440 C 350 470, 330 490, 320 520 C 310 545, 305 575, 285 595 C 270 612, 250 615, 235 605 C 220 593, 215 575, 210 555 C 200 525, 185 510, 175 480 C 165 450, 150 435, 145 405 C 138 375, 130 360, 125 335 C 118 310, 105 290, 110 265 C 115 235, 130 220, 145 200 C 165 175, 175 165, 180 145 C 185 125, 195 105, 215 90 C 230 75, 245 60, 260 50 Z";

export const BharatMap = () => {
  return (
    <div className="relative w-full aspect-[6/7] max-h-[440px] mx-auto">
      <svg
        viewBox="0 0 600 680"
        className="w-full h-full"
        data-testid="bharat-map-svg"
      >
        <defs>
          <linearGradient id="mapGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#1B2545" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#0A1128" stopOpacity="0.6" />
          </linearGradient>
          <radialGradient id="glow" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0%" stopColor="#C5A880" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#C5A880" stopOpacity="0" />
          </radialGradient>
          <pattern id="hatch" width="6" height="6" patternUnits="userSpaceOnUse">
            <path d="M0 6 L6 0" stroke="rgba(197,168,128,0.08)" strokeWidth="0.6" />
          </pattern>
        </defs>

        <path
          d={INDIA_PATH}
          fill="url(#mapGrad)"
          stroke="rgba(197,168,128,0.45)"
          strokeWidth="1"
        />
        <path d={INDIA_PATH} fill="url(#hatch)" />

        {PINS.map((p, i) => (
          <g key={p.name} data-testid={`map-pin-${p.name.toLowerCase().replace(/\s+/g, "-")}`}>
            <circle
              cx={p.x}
              cy={p.y}
              r="22"
              fill="url(#glow)"
              opacity={p.primary ? 0.9 : 0.55}
            >
              <animate
                attributeName="r"
                values="14;26;14"
                dur={`${3 + (i % 3)}s`}
                repeatCount="indefinite"
              />
            </circle>
            <circle
              cx={p.x}
              cy={p.y}
              r={p.primary ? 4 : 2.6}
              fill={p.primary ? "#E27222" : "#C5A880"}
              stroke="#F4F4F0"
              strokeWidth="1"
            />
            <text
              x={p.x + 10}
              y={p.y + 4}
              fontSize="10"
              fill="#F4F4F0"
              opacity="0.78"
              fontFamily="Outfit, sans-serif"
            >
              {p.name}
            </text>
          </g>
        ))}
      </svg>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="absolute bottom-3 left-3 text-[0.65rem] text-ivory/40 font-display tracking-[0.3em]"
      >
        BHARAT
      </motion.div>
    </div>
  );
};

export default BharatMap;
